import * as React from "react";
import { forwardRef } from "react";
const SvgSidebar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, className: "feather feather-sidebar", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 18, x: 3, y: 3, rx: 2, ry: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M9 3v18" }));
const ForwardRef = forwardRef(SvgSidebar);
export default ForwardRef;
